import _objectSpread from "/apps2/jenkins/jobs/bpg_yunying_cas_prod_fe_pipeline/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";

/* eslint-disable max-lines-per-function */
import isPromise from 'is-promise';
import { isFSA } from 'flux-standard-action';
export default function thunkPromiseMiddleware(_ref) {
  var dispatch = _ref.dispatch,
      getState = _ref.getState;
  return function (next) {
    return function (action) {
      // 判断是不是标准的{type: ..., payload: ... }形式
      if (!isFSA(action)) {
        // action是不是一个promise
        if (isPromise(action)) {
          return action.then(dispatch);
        } else {
          // 判断action是不是function，如果是thunk将dispatch和getState传入，不是的话直接调用next
          return typeof action === 'function' ? action(dispatch, getState) : next(action);
        }
      } // redux-promise形式


      if (isPromise(action.payload)) {
        // 直接将promise的值当做payload dispatch出去
        return action.payload.then(function (result) {
          return dispatch(_objectSpread(_objectSpread({}, action), {}, {
            payload: result
          }));
        }).catch(function (error) {
          dispatch(_objectSpread(_objectSpread({}, action), {}, {
            payload: error,
            error: true
          }));
          return Promise.reject(error);
        });
      } else if (action.payload === 'function') {
        // 如果action.payload是一个方法，将dispatch, getState传入，payload值变成方法执行返回值
        return dispatch(_objectSpread(_objectSpread({}, action), {}, {
          payload: action.payload(dispatch, getState)
        }));
      } else {
        // 都不是  直接调用next
        return next(action);
      }
    };
  };
}